import { Slider } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

export const VideoSlider = withStyles({
    root: {
        height: 5,
    },
    thumb: {
        height: 14,
        width: 14,
        backgroundColor: '#fff',
        borderRadius: 8,
        border: 'none',
        marginTop: -5,
        '&:focus, &:hover, &$active': {
            boxShadow: 'inherit',
        },
        zIndex: 1009,
        marginLeft: '5px',
    },
    track: {
        marginLeft: '3px',
        width: 'calc(100% - 4px)',
        height: 5,
        color: '#DB2C29',
    },
    rail: {
        marginLeft: '3px',
        width: 'calc(100% - 4px)',
        height: '100%',
        color: '#fff',
    },
})(Slider);

export const videoSliderStyles = () => ({
    videoSlider: {
        padding: 0,
        position: 'relative' as 'relative',
    },
});
